import styled from 'styled-components';

export const UiOrganizationResourcePage = styled.div`
	display: block;
`;